import { useSelector } from "react-redux";
import { getCurrentEnvironment } from "../Selectors/app";

export const useEnvironment = () => {
	const environment = useSelector(getCurrentEnvironment);
	return environment.name;
};
